export const getFilledFields = (wizard) => {
  let filledFields = [];

  wizard?.components?.forEach(page => {
    page?.components?.forEach(component => {
      if (component.component?.input && component.getValue()) {
        filledFields.push(component);
      }

      // If the component has nested components, recursively check those as well
      if (component.components) {
        filledFields = filledFields.concat(getFilledFields(component));
      }
    });
  });

  return filledFields;
}

export const countTotalQuestions = (form) => {
  let count = 0;

  // Helper function to count components recursively
  const countComponents = (components) => {
    if (!Array.isArray(components)) return; // Ensure components is an array
    components.forEach(component => {
      if (component?.component?.input) {
        count++;
      }
      // Recursively count nested components if they exist
      if (Array.isArray(component.components)) {
        countComponents(component.components);
      }
    });
  };

  // Ensure form.components exists and is an array
  if (Array.isArray(form?.components)) {
    form.components.forEach(page => {
      if (Array.isArray(page?.components)) {
        countComponents(page.components);
      }
    });
  }

  return count;
};
